
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Grid extends Vue {
    @Prop({default:true}) fluid ?:boolean;
    @Prop({default:false}) expanded ?:boolean;
    @Prop({default:false}) padded ?:boolean;

}
